import { render, staticRenderFns } from "./LocalEmpEntry.vue?vue&type=template&id=644fe35e&"
import script from "./LocalEmpEntry.vue?vue&type=script&lang=js&"
export * from "./LocalEmpEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports